// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2_rmD","show":"styles_show__FNW2H","loader":"styles_loader__GFId4","rotation":"styles_rotation__YQF_C","overlay":"styles_overlay__K9NZA"};